import React from 'react';
import YetAnotherLightbox from "./YetAnotherLightbox";
import ErrorBoundary from "./ErrorBoundary";
import Svg from "./Svg";

/**
 * @typedef {Object} ProductMediaItemModel
 * @property {string} fullSrc - The full-size image source URL.
 * @property {string} previewSrc - The preview image source URL.
 * @property {string} thumbnailSrc - The thumbnail image source URL.
 * @property {string} alt - The alternative text for the image.
 * @property {string} mimeType - The MIME type of the image.
 */

const LightboxImages = (props) => {
    const {
        productLabelsHtml,
        mediaItems,
        currentImage: currentImageIndex,
        onClickShowModal,
        onClickThumbnail
    } = props;

    if (!mediaItems || mediaItems.length < 1)
        return null;

    const currentImage = mediaItems[currentImageIndex];

    return <>
        {productLabelsHtml &&
            <div className="product-labels is-product-gallery" dangerouslySetInnerHTML={{ __html: productLabelsHtml }}></div>
        }

        <div className="row product-media">
            <div className="small-12 medium-12 large-10 columns large-order-1">
                <figure className="product-media__main-image-container">
                    <a data-src={currentImage.src}
                        itemProp="url"
                        onClick={() => onClickShowModal(currentImageIndex)}
                        className="product-image"
                    >
                        <img className="product-media__main-image"
                            itemProp="image"
                            src={currentImage.previewSrc}
                            alt={currentImage.alt} />

                        {currentImage.type === 'video' &&
                            <div className="product-media-item__play-button">
                                <Svg icon="play-circle" label="Play" extraClass="text--7xl"/>
                            </div>}
                    </a>
                </figure>
            </div>

            <div className="product-media__thumbnails-list small-12 medium-12 large-2 columns medium-flex-dir-column">
                <div className="row">
                    {mediaItems.map((mediaItem, index) =>
                        <div className="product-media-item columns large-12" key={index}>
                            <a
                                data-src={mediaItem.src}
                                itemProp="url"
                                onClick={() => onClickThumbnail(index)}
                                className={`product-media__media-link`}
                            >
                                <img
                                    className={"product-media__media-preview " + (currentImage === index ? 'active' : '')}
                                    itemProp="image" src={mediaItem.thumbnailSrc}
                                    alt={mediaItem.alt} />

                                {mediaItem.type === 'video' &&
                                    <div className="product-media-item__play-button">
                                        <Svg icon="play-circle" label="Play" extraClass="text--4xl"/>
                                    </div>}
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </div>

        <ErrorBoundary>
            <YetAnotherLightbox
                showThumbnails={true}
                showImageCount={false}
                {...props}
            />
        </ErrorBoundary>
    </>
}


export default LightboxImages;
